import React, { useRef, useEffect } from 'react';
import './App.css';
import content from './content/main.json'
import projects from './content/projects.json'
import { Image } from "antd";

function Header(props: { title: string, image: string }) {
  return (
    <div className="header anton-regular">
      <h1>{props.title}</h1>
      <img src={props.image} alt="Jahnel's Group logo" />
    </div>
  );
}

function Introduction(props: { title: string, subtitle: string, description: string, image: string }) {
  return (
    <section className="introduction">
      <img src={props.image} alt="Aleksandr's photo" />
      <div>
        <h2 className='franklin-bold'>{props.title}</h2>
        <h3 className='franklin-blue'>{props.subtitle}</h3>
        <p className='franklin-regular'>{props.description}</p>
      </div>
    </section>
  );
}

interface ProjectProps {
  company: string;
  title: string;
  description: string;
  company_logo: string;
  images: string[];
  images_alt: string[];
  skills: string[];
  links: { url: string, text: string }[];
}

function Project(props: ProjectProps) {

  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      const handleScroll = (event: WheelEvent) => {
        if (event.deltaY !== 0) {
          event.preventDefault(); 
          container.scrollLeft += event.deltaY;
        }
      };

      container.addEventListener('wheel', handleScroll);

      return () => container.removeEventListener('wheel', handleScroll);
    }
  }, []);


  return (
    <section className='Project'>
      <div className='Project-Div'>
        <div className='Project-Main'>
          <div className='Project-Title'>
              <img src={props.company_logo} alt={`${props.company}'s lgoo`} />
              <h2 className='franklin-bold'>{props.company} - {props.title}</h2>
          </div>
          <p className='franklin-regular description'>
            {props.description}
          </p>
          {/* Render the links here */}
          <div className='Project-Links franklin-regular'>
            {props.links.map((link, index) => (
              <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                {link.text}
              </a>
            ))}
          </div>
        </div>
        <div ref={containerRef} className='Project-Images-Container'>
        <div className='Project-Images'>
          {props.images.map((image, index) => (
            <Image width={500} key={index} src={image} alt={props.images_alt[index]} />
            
          ))}
        </div>
        <p className='franklin-regular scroll-to-view-more'>
            Scroll to view more →
        </p>
        </div>
      </div>
    </section>
  );
}

function App() {
  return (
    <div className="App">
      <Header title={content.header.title} image={content.header.image} />
      <Introduction
        title={content.introduction.title}
        subtitle={content.introduction.subtitle}
        description={content.introduction.description}
        image={content.introduction.image}
      />    
      {projects.map((project, index) => (
        <Project
          key={index}
          company={project.company}
          title={project.title}
          description={project.description}
          company_logo={project.company_logo}
          images={project.images}
          images_alt={project.images_alt}
          skills={project.skills}
          links={project.links || []}
        />
      ))}

    </div>
  );
}

export default App;
